<template>
    <div class="d-flex align-items-center">
        <b-button
            title="Update Commissions"
            variant="outline-primary"
            @click="$bvModal.show(`setup-commissions-modalId-${params.data.id}`)"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']" />
        </b-button>
        <setup-commissions-modal
            :modalId="`setup-commissions-modalId-${params.data.id}`"
            :initialValues="params.data"
            @refreshReservation="refreshReservation"
        />
    </div>
</template>

<script>
import SetupCommissionsModal from './setup-commissions-modal.vue';

export default {
    components: { SetupCommissionsModal },
    methods: {
        refreshReservation(callback) {
            this.params.refreshReservation(callback);
        },
    },
};
</script>
